export interface INgxGalleryAction {
  icon: string;
  disabled?: boolean;
  titleText?: string;

  onClick: (event: Event) => void;
}

export class NgxGalleryAction implements INgxGalleryAction {
  icon: string;
  disabled?: boolean;
  titleText?: string;

  onClick: (event: Event) => void;

  constructor(action: INgxGalleryAction) {
    this.icon = action.icon;
    this.disabled = action.disabled ? action.disabled : false;
    this.titleText = action.titleText ? action.titleText : "";

    this.onClick = action.onClick;
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/ngx-gallery/ngx-gallery-action.model.ts